<template>
	<div class="install-codings-step">
		<div
			class="coding-checkbox-row"
			:class="{ selected: value_local?.codings?.install }"
			@click="toggleCodings"
			@keydown.enter="toggleCodings"
			@keydown.space.prevent="toggleCodings"
			tabindex="10"
			startup
		>
			<div class="coding-radio-circle" :class="{ checked: value_local?.codings?.install }">
				<icon v-if="value_local?.codings?.install" icon="check" class="check-icon" group="regular" />
			</div>
			<span class="coding-label">{{ $t('install.codings.f.install') }}</span>
		</div>

		<div
			class="coding-checkbox-row"
			:class="{ selected: value_local?.useDefaultFloatingCenterGroup }"
			@click="toggleFloatingCenters"
			@keydown.enter="toggleFloatingCenters"
			@keydown.space.prevent="toggleFloatingCenters"
			tabindex="11"
		>
			<div class="coding-radio-circle" :class="{ checked: value_local?.useDefaultFloatingCenterGroup }">
				<icon v-if="value_local?.useDefaultFloatingCenterGroup" icon="check" class="check-icon" group="regular" />
			</div>
			<span class="coding-label">{{ $t('install.codings.f.install-floating-centers') }}</span>
		</div>
	</div>
</template>

<script>
	import _ from 'lodash'

	export default {
		props: ['modelValue'],
		emits: ['update:modelValue'],
		data() {
			return {
				value_local: {
					codings: {
						install: true,
					},
					useDefaultFloatingCenterGroup: true,
				}
			}
		},
		watch: {
			modelValue: {
				deep: true,
				immediate: true,
				handler(val) {
					this.value_local = _.cloneDeep(val)
				}
			}
		},
		methods: {
			toggleCodings() {
				if (!this.value_local.codings) {
					this.value_local.codings = {}
				}
				this.value_local.codings.install = !this.value_local.codings.install
				this.emitValue()
			},
			toggleFloatingCenters() {
				if (!this.value_local.codings) {
					this.value_local.codings = {}
				}
				this.value_local.useDefaultFloatingCenterGroup = !this.value_local.useDefaultFloatingCenterGroup
				this.emitValue()
			},
			emitValue() {
				this.$emit('update:modelValue', this.value_local)
			}
		}
	}
</script>

<style></style>
